module.exports = __webpack_public_path__ + "img/street-sounds.c71b3220.png";